export const EMAIL = "email"
export const POSTCODE = "postcode"
